(function () {
  if (window.__productHighlightsInit) return;
  window.__productHighlightsInit = true;

  var prefersReduced =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function countUp(el) {
    var target = parseFloat(el.getAttribute("data-count-to"));
    var suffix = el.getAttribute("data-count-suffix") || "";
    if (isNaN(target)) return;

    if (prefersReduced) {
      el.textContent = target + suffix;
      return;
    }

    var duration = 900;
    var startedAt = null;

    function step(timestamp) {
      if (startedAt === null) startedAt = timestamp;
      var progress = Math.min((timestamp - startedAt) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }

    el.textContent = "0" + suffix;
    requestAnimationFrame(step);
  }

  function activate(el) {
    el.classList.add("is-visible");
    var counter = el.querySelector("[data-count-to]");
    if (counter) countUp(counter);
  }

  function init() {
    var items = document.querySelectorAll(".m-phl-reveal:not(.is-visible)");
    if (!items.length) return;

    if (prefersReduced || !("IntersectionObserver" in window)) {
      Array.prototype.forEach.call(items, activate);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          activate(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    );

    Array.prototype.forEach.call(items, function (item) {
      observer.observe(item);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
